import { Label, Row, TextArea, TextInput } from "@app/components";
import { PriceForm } from "@app/components/form/PriceForm";
import { AccountCodeSelect } from "@app/components/form/selects/features/AccountCodeSelect";
import { OrderModeSelect } from "@app/components/form/selects/features/OrderModeSelect";
import React, { forwardRef } from "react";
import { TagSelect } from "@app/components/form/selects/features/TagSelect";
import { StepSelect } from "@app/components/form/selects/features/StepSelect";
import { ProductVariationSelect } from "@app/components/form/selects/features/ProductVariationSelect";
import { StyledForms } from "@app/components/styled/form/Form";
import { InputFile, InputFileRef } from "@app/components/form/InputFile";
import { InfoBulle } from "@app/components/form/InfoBulle";
import { TEXTE_AIDE_HORAIRES } from "@app/components/form/aide-horaires";
import { ScheduleForm } from "@app/components/form/ScheduleForm";
import { FormSection } from "@app/components/styled/form/FormSection";
import { Toggle } from "@app/components/form/Toggle";
import { ScheduleAvailabilityTypeEnum } from "@app/common";
import { View } from "react-native";
import { useFormContext } from "react-hook-form";

export const PackForm = forwardRef<any>((_, ref: React.ForwardedRef<InputFileRef>) => {
  const { watch } = useFormContext();

  const availabilityType = watch('availabilityType');

  return (
    <StyledForms.Form>

      <InputFile name="image" ref={ref} />

      <FormSection.Section>
        <FormSection.Title>Informations générales</FormSection.Title>
        <FormSection.Content>

          <TextInput
            name="name"
            label="Nom"
            placeholderTextColor="white"
            autoCapitalize="none" />

          <TextArea
            name="description"
            label="Description"
            placeholderTextColor="white"
            autoCapitalize="none" />

          <TagSelect name='tags' isMultiple />

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Informations avancées</FormSection.Title>
        <FormSection.Content>

          <AccountCodeSelect name="accountCode" />

          <OrderModeSelect
            name="orderModes"
            isMultiple />

          {/* `zIndex` sur la rangée, pas seulement sur la bulle : en RN-Web un
              frère rendu après (la barre ci-dessous) recouvre le précédent, et
              un zIndex ne joue qu'entre frères (retour Maxence, 04/11/2026). */}
          <Row justify="flex-end" style={{ zIndex: 10 }}>
            <InfoBulle texte={TEXTE_AIDE_HORAIRES} testID="aide-horaires" />
          </Row>

          <Toggle
            name="availabilityType"
            options={[
              { title: "Toujours disponible", value: ScheduleAvailabilityTypeEnum.always },
              { title: "Jours spécifiques", value: ScheduleAvailabilityTypeEnum.specificDays },
            ]} />

          {availabilityType === ScheduleAvailabilityTypeEnum.specificDays && (
            <ScheduleForm
              label="Horaires de disponibilité"
              aide={<InfoBulle texte={TEXTE_AIDE_HORAIRES} />}
              names={{
                schedule: 'availabilitySchedule',
                selectedDays: 'selectedDays',
                startTime: 'startTime',
                endTime: 'endTime',
              }} />
          )}

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Configuration</FormSection.Title>
        <FormSection.Content>

          <StepSelect
            name="packToSteps"
            transform={{
              value: (item) => ({ step: item }),
              accessor: (item) => (item.step?._id),
              display: (item) => (item?.step?.name)
            }}
            isMultiple />

          <ProductVariationSelect
            name="packToProductVariations"
            label="Produits offerts"
            transform={{
              value: (item) => ({ productVariation: item }),
              accessor: (item) => (item.productVariation?._id),
              display: (item) => (item?.productVariation?.name)
            }}
            isMultiple />

          <PriceForm
            label="Tarifs"
            names={{
              price: "price",
              tax: "tax",
              takeAwayPrice: "takeAwayPrice",
              takeAwayTax: "takeAwayTax",
              deliveryPrice: "deliveryPrice",
              deliveryTax: "deliveryTax",
              onSpotPrice: "onSpotPrice",
              onSpotTax: "onSpotTax",
            }} />

        </FormSection.Content>
      </FormSection.Section>

    </StyledForms.Form>
  );
});
